module.exports = "<chassis-form-layout\n    [pageMode]=\"pageMode\"\n    [singular]=\"singular\"\n    [plural]=\"plural\"\n    [title]=\"title\"\n    [routePrefix]=\"routePrefix\"\n    [pluginPrefix]=\"pluginPrefix\"\n    [(form)]=\"form\"\n    [toolbar]=\"toolbar\"\n    [pluginData]=\"pluginData\">\n</chassis-form-layout>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/pages/roles/edit/edit.page.html
// module id = ./libs/chassis-core/src/app/pages/roles/edit/edit.page.html
// module chunks = main